import PropTypes from "prop-types";
import React from "react";

class NavBar extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.node,
      className: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      className: "",
    };
  }

  render() {
    const { className, children } = this.props;

    return (
      <nav
        className={`navbar navbar-static-top ${className}`}
        role="navigation"
      >
        {children}
      </nav>
    );
  }
}

export { NavBar };
